// helpers
export const isFreemium = (fee: Object): boolean =>
    fee && fee.access_type.name === 'freemium';
export const isSubscription = (fee: Object): boolean =>
    fee && fee.access_type.name === 'subscription';

export const decodeHTMLEntities = str => {
    let text = '';
    let parser = new DOMParser();

    if (str.includes('href=')) {
        text = str;
        return text;
    }

    text = parser.parseFromString('<!doctype html><body>' + str, 'text/html')
        .body.textContent;

    return text;
};



// WEBPACK FOOTER //
// ./src/utils/helpers.js